module.exports = __webpack_public_path__ + "static/AI_Playbook-logo-cbe8d01e24b38f40fe94ebd33c143585.svg";